import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  dateFieldsWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    '& .field': {
      marginTop: 8
    },
    '& > div:nth-child(1)': {
      minWidth: 190,
      marginRight: 8
    }
  }
})

export default useStyles
